import { useContext } from 'react';
import { AppMethodsContext } from '../../providers/AppMethodsProvider';

export default function useAppMethods() {
  return useContext(AppMethodsContext);
}
